import { render } from "./funded-account.vue?vue&type=template&id=31c7e048"
import script from "./funded-account.vue?vue&type=script&lang=js"
export * from "./funded-account.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__